export const STATUS_SANEAMENTO = {
  PENDENTE_PARECER: "Pendente de Parecer",
  EMITIDO: "Emitido",
  CANCELADO: "Cancelado",
  RESOLVIDO: "Resolvido",
} as const;
